// extracted by mini-css-extract-plugin
module.exports = {"noSelect":"CustomAutocomplete_noSelect__Mxph_"};